module.exports = __webpack_public_path__ + "img/bb.0a54baba.png";